export default "__VITE_ASSET__C8k_Oquc__"